define('Components/Comein/js/views/pages/ComeinPageView',['PageView','template!Components/Comein/templates/presentation', 'WidgetCollectionView'],function(PageView,template, WidgetCollectionView){
   return PageView.extend({
       pageName:'Comein',
       events:{
           'click .notice-title':'toggleTitle'
       },
       initialize:function(){



           // PageView constructor heritage
           PageView.prototype.initialize.apply(this,arguments);
           console.log('ComeinPageView !');
       },
       toggleTitle:function(e){
           $(e.currentTarget).css('color','red');
       }
   });
});
